import * as React from "react";
import PropTypes from "prop-types";

import IconButton from "ui/IconButton";

import AddIcon from "assets/svg/add.svg";

const IconButtonFileInput = (props) => {
  const { Icon, extensions, onChange, buttonProps } = props;

  const renderIcon = () => {
    if (!Icon) return <AddIcon />;
    return <Icon />;
  };

  return (
    <IconButton
      id="icon-button-for-input"
      component="label"
      variant="header"
      role={undefined}
      {...buttonProps}
    >
      {renderIcon()}
      <input
        type="file"
        id="file-input-in-button-shape"
        accept={extensions.join(", ")}
        style={{ display: "none" }}
        onChange={onChange}
      />
    </IconButton>
  );
};

IconButtonFileInput.propTypes = {
  Icon: PropTypes.any,
  extensions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  buttonProps: PropTypes.object,
};

export default IconButtonFileInput;
